import React, { useEffect, useId, useRef, useState } from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { StyledPrimeReactInput } from 'styles/v2/Styles.styled';
import useIsReadOnlyMode from '../compiler/hooks/useIsReadOnlyMode';
import SmartLabel, { TSmartLabelProps } from '../labels/SmartLabel';

type Props = Partial<TSmartLabelProps> & {
  defaultValue: number | null;
  onChanged(name: string, newValue: number | null): void;
  name: string;
  disabled?: boolean;
  placeholder?: string;
  id?: string;
  maxFractionDigits?: number;
};

const WizardNumberInput: React.FC<Props> = ({
  defaultValue,
  onChanged,
  name,
  label,
  required,
  labelStyle,
  tooltip,
  tooltipPosition,
  error,
  placeholder,
  id,
  disabled,
  maxFractionDigits = 2,
}) => {
  const fallbackInputId = useId();
  const inputId = id || fallbackInputId;
  const isReadOnly = useIsReadOnlyMode() || disabled;

  const [value, setValue] = useState<number | null>(defaultValue);
  const latestValueRef = useRef<number | null>(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      {label && (
        <SmartLabel
          label={label}
          required={required}
          labelStyle={labelStyle}
          tooltip={tooltip}
          tooltipPosition={tooltipPosition}
          error={error}
          hasValue={defaultValue !== null}
        />
      )}
      <StyledPrimeReactInput
        as={InputNumber}
        inputId={inputId}
        value={value}
        onValueChange={(e) => {
          setValue(e.value ?? null);
          latestValueRef.current = e.value ?? null;
        }}
        onBlur={() => {
          onChanged(name, latestValueRef.current);
        }}
        disabled={isReadOnly}
        placeholder={isReadOnly ? undefined : placeholder}
        useGrouping={false}
        maxFractionDigits={maxFractionDigits}
      />
    </div>
  );
};

export default WizardNumberInput;
